import { Metamodel } from 'app/model/base/model';
import { validatePartitionNames } from 'app/shared/utils/store-settings-validation.util';
import { IAttribute, LakehouseLinkedService, StoreSettingPartitionKey } from 'shell-models-lib';
import { AdvancedStoreWriteSettings } from './advanced-store-write-settings';

@Metamodel.model({
    name: 'LakehouseWriteSettings',
    tags: {
        linkedServiceModel: Metamodel.modelFor(LakehouseLinkedService)
    }
})
export class LakehouseWriteSettings extends AdvancedStoreWriteSettings {
    public static readonly PARTITION_OPTION: IAttribute;
    public static readonly TABLE_ACTION: IAttribute;
    public static readonly PARTITION_KEYS: IAttribute;

    @Metamodel.attribute({
        association: 'PARTITION_OPTION',
        templatable: true,
        accepts: ['String'],
        display: stringResources.ModelName_Enable_Sink_Partition
    })
    public enablePartitionOption?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_Partition_Columns,
        association: 'PARTITION_KEYS',
        templatable: true,
        accepts: ['Array'],
        defaultValue: [],
        constraint: {
            validator: validatePartitionNames
        }
    })
    public partitionNameList?: StoreSettingPartitionKey[] = [];

    @Metamodel.attribute({
        display: stringResources.TableAction,
        association: 'TABLE_ACTION',
        templatable: true,
        accepts: ['String']
    })
    public tableActionOption?: string = 'Append';
}
